import { CreateStaffDto, ListStaffParamsDto } from "../entities/dto/staff.dto";
import { Staff } from "../entities/interfaces/staffs";
import Api, { ApiResponse } from "../utils/axios";

export const list = async (
  params: ListStaffParamsDto
): Promise<ApiResponse<Staff[]>> => {
  return await Api.get(`/staffs?${new URLSearchParams(params)}`);
};

export const listAll = async (
  params: ListStaffParamsDto
): Promise<ApiResponse<Staff[]>> => {
  return await Api.get(`/staffs/all?${new URLSearchParams(params)}`);
};

export const create = async (
  createStaffDto: CreateStaffDto
): Promise<ApiResponse<Staff[]>> => {
  return await Api.post("/staffs", createStaffDto);
};

export const update = async (
  id: string,
  updateStaffDto: CreateStaffDto
): Promise<ApiResponse<Staff[]>> => {
  return await Api.patch(`/staffs/${id}`, updateStaffDto);
};

const StaffService = { list, create, update, listAll };
export default StaffService;
